import React, { useContext, useEffect } from "react"
import { useFormik } from "formik"
import {
  Box,
  Button,
  Heading,
  Alert,
  AlertIcon,
  Input,
  InputGroup,
  Stack,
  Text
} from "@chakra-ui/react"
import * as yup from 'yup'
import { ArrowForwardIcon } from "@chakra-ui/icons"
import { useLocation, useNavigate } from "react-router"
import { Context } from "../../store";
import { createHmacString } from "../../helpers";
import { withMask } from "use-mask-input"
import { accentOutline } from "../../accent";

const FillForm = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { branch_id, branch_name, phone, user, changeStore } = useContext(Context)

  const formik = useFormik({
    initialValues: {
      birthday: '',
      first_name: '',
      last_name: '',
    },
    validationSchema: yup.object().shape({
      first_name: yup.string().required('Пожалуйста заполните поле'),
      last_name: yup.string().required('Пожалуйста заполните поле'),
      birthday: yup.string().min(10, 'Пожалуйста введите корректную дату').max(10, 'Пожалуйста введите корректную дату').required('Пожалуйста заполните поле'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      // phone lives only in the in-memory context: a reload or a direct open of this page leaves it empty
      if ((phone || '').replace(/[^\d]/g, '').length !== 11) {
        setSubmitting(false)
        navigate({ pathname: '/', search: location.search })
        return
      }
      const body = {
        ...values,
        phone_number: '+' + phone.replace(/[^\d]/g, ''),
        birthday: values.birthday,
        branch_id: branch_id,
      }
      try {
        const token = createHmacString(new Date().getTime().toString())
        const response = await fetch(process.env.REACT_APP_API_URL + `/wallet/front/user/info`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
          body: JSON.stringify(body),
        })
        const json = await response.json()
        const data = json.data

        if (data.id) {
          changeStore({ user: data })
          navigate({
            pathname: '/set-wallet',
            search: location.search
          })
        }
      } catch (e) {

      } finally {
        setSubmitting(false)
      }
    },
  })

  useEffect(() => {
    if (user) {
      formik.setFieldValue("first_name", user.first_name)
      formik.setFieldValue("last_name", user.last_name)
      if (user.birthday) {
        formik.setFieldValue("birthday", user.birthday)
      }
    }
  }, [user])

  // the server rejects a birthday change for a year (anti-farming of the birthday bonus), so do not offer to edit it
  const birthdayLocked = !!user?.birthday

  return (
    <form onSubmit={formik.handleSubmit} style={{width: '100%'}}>
      <Stack spacing={4}>
        <Box marginBottom={4}>
          <Heading size="md" as="h2" textAlign="center">Осталось заполнить поля</Heading>
          <Text textAlign="center">И вы сможете скачать карту лояльности</Text>
        </Box>
        {birthdayLocked && (
          <Alert status="info" borderRadius="md">
            <AlertIcon />
            У зарегистрированного пользователя дату рождения изменить нельзя
          </Alert>
        )}
        <InputGroup>
          <Input
            value={formik.values.first_name || ''}
            onChange={formik.handleChange}
            name="first_name"
            placeholder='Введите Имя'
            required
          />
        </InputGroup>
        <InputGroup>
          <Input
            value={formik.values.last_name || ''}
            onChange={formik.handleChange}
            name="last_name"
            placeholder='Введите Фамилию'
            required
          />
        </InputGroup>
        <Text style={{ fontWeight: 600 }}>
          Введите дату рождения день-месяц-год
        </Text>
        <InputGroup>
          <Input
            value={formik.values.birthday || ''}
            isDisabled={birthdayLocked}
            onChange={formik.handleChange}
            name="birthday"
            placeholder='Введите дату рождения день-месяц-год'
            ref={withMask("99-99-9999")}
            required
          />
        </InputGroup>
        <Button loadingText="Сохранение данных" isLoading={formik.isSubmitting} type="submit" rightIcon={<ArrowForwardIcon/>} colorScheme='teal' variant='outline' sx={accentOutline}>
          Продолжить
        </Button>
      </Stack>
    </form>
  )
}

export default FillForm